import { classNames, FlexCenter, Spinner, TextLabel } from "@opensea/ui-kit"
import { Check, ErrorFilled } from "@opensea/ui-kit/icons"
import type { MouseEventHandler, ReactNode } from "react"

type WalletStatusIndicatorProps = {
  state: "pending" | "complete" | "error"
  children: ReactNode
  onClick?: MouseEventHandler<HTMLDivElement>
}

export function WalletStatusIndicator({
  state,
  children,
  onClick,
}: WalletStatusIndicatorProps) {
  return (
    <FlexCenter
      className={classNames("h-8 gap-2 rounded-md px-3 py-1", {
        "bg-rare-transparent-1 text-rare": state === "pending",
        "bg-success-1-transparent-1 text-success-1": state === "complete",
        "bg-error-1-transparent-1 text-error-1": state === "error",
        "cursor-pointer": Boolean(onClick),
      })}
      onClick={onClick}
    >
      {state === "pending" && <Spinner className="fill-rare" size="xs" />}
      {state === "complete" && <Check size={16} />}
      {state === "error" && <ErrorFilled size={16} />}

      <TextLabel>{children}</TextLabel>
    </FlexCenter>
  )
}
